import React, { useState } from "react"
import {
  Card,
  CardBody,
  Col,
  Nav,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap"
import { connect } from "react-redux"
import PrivateMessage from "./privateMessage"
import MenuFeatureHyperlinks from "../menuFeatureHyperlinks"

let PrivateMessageMenuFeature = ({
  feature,
  isEventFeature,
  selectedEvent,
  vendorConfig,
}) => {
  const TABS = {
    FEATURE: 1,
    HYPERLINKS: 2,
  }
  const [activeTab, setActiveTab] = useState(TABS.FEATURE)

  const markIfIsActive = tab => {
    return activeTab === tab ? "active" : ""
  }

  return (
    <Card>
      <CardBody className="shadow-sm">
        {isEventFeature &&
        (vendorConfig?.nfc_hyperlinks ||
          vendorConfig?.communication_hyperlinks) ? (
          <React.Fragment>
            <Row>
              <Col>
                <Nav pills tabs>
                  <NavLink
                    className={markIfIsActive(TABS.FEATURE)}
                    onClick={() => {
                      setActiveTab(TABS.FEATURE)
                    }}
                  >
                    <span style={{ fontSize: "16px" }}>
                      {feature?.placeholder}
                    </span>
                  </NavLink>
                  <NavLink
                    className={markIfIsActive(TABS.HYPERLINKS)}
                    onClick={() => {
                      setActiveTab(TABS.HYPERLINKS)
                    }}
                  >
                    <span style={{ fontSize: "16px" }}>Hyperlinks</span>
                  </NavLink>
                </Nav>
                <TabContent activeTab={activeTab}>
                  <TabPane tabId={TABS.FEATURE} style={{ animation: "none" }}>
                    <PrivateMessage feature={feature} />
                  </TabPane>
                  <TabPane
                    tabId={TABS.HYPERLINKS}
                    style={{ animation: "none" }}
                  >
                    <MenuFeatureHyperlinks
                      event_id={selectedEvent?.id}
                      menu_feature={feature}
                    />
                  </TabPane>
                </TabContent>
              </Col>
            </Row>
          </React.Fragment>
        ) : (
          <PrivateMessage feature={feature} />
        )}
      </CardBody>
    </Card>
  )
}

const mapStateToProps = state => ({
  selectedEvent: state.experiences.selectedEvent,
  vendorConfig: state.clients.vendorConfig,
})

export default connect(mapStateToProps)(PrivateMessageMenuFeature)
